import React from "react";
import { ClipLoader } from "react-spinners";

function LoadingPage() {
  return (
    <div className="w-screen h-screen absolute z-50 bg-white opacity-70 font-noto-sans-thai overflow-hidden">
      <div className="flex flex-col gap-10 w-full h-full items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <ClipLoader color="#C34A25CC" loading={true} size={35} />
          <p className="text-sm font-normal">กำลังโหลดข้อมูล...</p>
        </div>
      </div>
    </div>
  );
}
export default LoadingPage;
